import { lazy } from 'react'

export const HitYourWeightLossV1 = lazy(
  () => import('./v1/HitYourWeightLossV1'),
)
